import { Message } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import { View } from 'react-native'
import { getDarkShadeColor, getLightShadeColor } from 'shared/utils'
import { ReplyMessage } from './reply_message_bar'

interface ReplyBubbleProps {
  replyMessage?: Message
  isSender?: boolean
}

export function MessageReplyBubble({
  replyMessage,
  isSender,
}: ReplyBubbleProps) {
  const styles = useStyles({ isSender })

  if (!replyMessage) {
    return
  }

  return (
    <View style={styles.container}>
      <ReplyMessage replyMessage={replyMessage} />
    </View>
  )
}

const useStyles = makeStyles((theme, { isSender }: { isSender?: boolean }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    alignSelf: 'stretch',
    marginHorizontal: 7,
    marginTop: 5,
    backgroundColor:
      theme.mode === 'dark' || isSender
        ? getDarkShadeColor(0.3)
        : getLightShadeColor(0.9),
  },
}))
